'use client'
import { Cart, Product } from "lib/bigcommerce/types";
import { BCOrder } from "lib/rest-service/types";
import { extractConsignments, extractLineItems } from "lib/utils";

export const ProductView = (
  siteId: string, 
  shopperId: string, 
  sku: string,
  gid: string,
) => {
  if (!window) return {};
  try {
    window.IntelliSuggest.init({
      siteId,
      context: `Product/${sku}`,
      seed: [sku]
    });
    window.IntelliSuggest.setShopperId(shopperId);
    window.IntelliSuggest.viewItem({ 
      sku: sku, 
      uid: gid 
    });
  } catch (err) {
    console.error('IntelliSuggest error:', err);
  }
};

export const BasketItems = (siteId:string, shopperId:string, cart: Cart) => {
  if (!window) return {};
    try {
      window.IntelliSuggest.init({
        siteId,
        context: 'Basket',
        seed: cart.lines.map(item => item.parentSKU)
      });
      window.IntelliSuggest.setShopperId(shopperId);
      
      cart.lines.forEach(item => {
        const intelliItem = {
          sku: item.parentSKU,
          childSku: item.sku,
          qty: item.quantity.toString(),
          price: item.cost.totalAmount.amount
        }
        window.IntelliSuggest.haveItem(intelliItem);
      });
      
      window.IntelliSuggest.inBasket({});
    } catch (err) {
      console.error('IntelliSuggest error:', err);
    }
};

export const OrderSale = (siteId: string, shopperId: string, order?: BCOrder, product?: Product) => {
    if (!order) {
        console.error("Order is undefined");
        return;
    }

    if (!window.IntelliSuggest) return {};

    try {
        window.IntelliSuggest.init({ siteId });
        window.IntelliSuggest.setShopperId(shopperId);
        
        const { shipping, downloads } = extractConsignments(order?.consignments);
        const shippingLineItems = extractLineItems(shipping);
        const downloadLineItems = extractLineItems(downloads);

        const lineItems = [...shippingLineItems, ...downloadLineItems];
        lineItems.forEach(item => {
          const variant = product?.variants?.find(v => item?.sku === v.sku);
          const intelliItem = {
            sku: variant ? product?.sku : undefined,
            childSku: item.sku,
            qty: item.quantity?.toString(),
            price: item.price_ex_tax
          }
          window.IntelliSuggest.haveItem(intelliItem);
        });

        window.IntelliSuggest.setCurrency({ code: order?.currency_code });

        window.IntelliSuggest.inSale({
            orderId: order?.id?.toString(),
            total: order?.total_inc_tax,
            city: order?.billing_address?.city,
            state: order?.billing_address?.state,
            country: order?.billing_address?.country_iso2
        });

    } catch (e) {
        console.error("Error in processing order sale:", e);
    }
};